import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataTablesRequest, ModelSearch } from 'projects/ProjetoBaseAngular/domain/models';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { TypesService } from 'projects/admin/src/domain/services';
import { MetaMsgTemplateButtonModel } from '../../../domain/models';
import { MetaMsgTemplateComponentType } from '../../../domain/types';
import { MetaMsgTemplateButtonService } from '../../../domain/services/meta-msg-template-button.service';
import { MetaMsgTemplateButtonModalComponent } from './msg-template-button-modal/msg-template-button-modal.component';

@Component({
  selector: 'app-meta-msg-template-button',
  templateUrl: './msg-template-button.component.html'
})
export class MetaMsgTemplateButtonComponent extends BaseCrudComponent<MetaMsgTemplateButtonModel> implements OnInit {
  @ViewChild('modal') modal: MetaMsgTemplateButtonModalComponent;

  @Input('metaMsgTemplateId') metaMsgTemplateId: string;
  @Output() autoSave: EventEmitter<any> = new EventEmitter<any>();

  searchMetaMsgTemplateId = new ModelSearch('metaMsgTemplateComponent.metaMsgTemplateId', OptionSearchType.Equals, SearchType.Guid);
  searchComponentTipo = new ModelSearch('metaMsgTemplateComponent.tipo', OptionSearchType.Equals, SearchType.Int, MetaMsgTemplateComponentType.Buttons);

  selectColumns = [
    { data: 'order' },
    { data: 'tipo' },
    { data: 'text' },
    { data: 'url' },
    { data: 'phoneNumber' }
  ];

  constructor(
    injector: Injector,
    readonly service: MetaMsgTemplateButtonService,
    readonly typesService: TypesService
  ) {
    super(injector, service);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  beforeDtRequest(dataTablesParameters: DataTablesRequest) {
    const searches = [];

    this.searchMetaMsgTemplateId.searchTerm = this.metaMsgTemplateId;
    searches.push(this.searchMetaMsgTemplateId);
    searches.push(this.searchComponentTipo);

    dataTablesParameters.searches = searches;

    return super.beforeDtRequest(dataTablesParameters);
  }

  create() {
    this.autoSave.emit();
    super.create();
  }
}
